var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.queriesArr),function(query,index){return _c('switch-component',{attrs:{"query":query,"id":index},on:{"stateChanged":_vm.onStateChanged}})}),_vm._v("\n  "+_vm._s(_vm.states)+"\n\n  "+_vm._s(_vm.allTrue)+"\n\n")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d35181a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/SwitchesComponent.vue
// module id = null
// module chunks = 